import React from 'react';
import {getAccessMethodById} from '../../enums/accessMethodEnum';
import {CustomStyleImage} from "../Styles";

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend
 * @Email: sgarcia@ibl.mx
 *
 * @Description AccessMethodIcon
 * @param {Number|Object} AccessMethodId: ID of the access method (required)
 * @param {String} className: Optional CSS class for styling (optional)
 * @returns {JSX.Element}
 */
const AccessMethodIcon = ({ AccessMethodId, className = '' }) => {
    const id = AccessMethodId && typeof AccessMethodId === 'object'
        ? AccessMethodId.id
        : AccessMethodId;

    const accessMethodData = getAccessMethodById(id);
    const IconComponent = accessMethodData?.icon;

    if (!IconComponent) return null;

    return (
        <IconComponent
            className={`btn-icon-svg-24px ${className}`}
            style={CustomStyleImage()}
        />
    );
};

export default AccessMethodIcon;
